export default __webpack_public_path__ + "static/media/badging.daba90c1.png";